class Schema {
    protocol?: string;
    host: string;
    port?: string;
    context?: string;
}

export abstract class AbstractRestService {

    private API_SCHEMA: Schema = {
        //host: '93.67.178.74',
        //host: 'localhost',
        //port: '8082'
        protocol: 'https',
        host: 'api-powercloud.vtsolutions.it'
    };

    protected constructor() {
    }

    get baseURL(): string {
        return AbstractRestService.getUrl(this.API_SCHEMA);
    }

    get powerCloudURL(): string {
        return `${AbstractRestService.getUrl(this.API_SCHEMA)}/PowerCloud`;
    }

    get configurationURL(): string {
        return `${AbstractRestService.getUrl(this.API_SCHEMA)}/configuration`;
    }

    get smURL(): string {
        return `${AbstractRestService.getUrl(this.API_SCHEMA)}/sm`;
    }

    private static getUrl(schema: Schema): string {
        const protocol = (schema.protocol ? schema.protocol : 'http').replace(/:$/, '');
        const port = (!schema.port) ? '' : (':' + schema.port);
        const host = schema.host ? schema.host : window.location.hostname;
        let context = schema.context ? schema.context : '';

        if (context.trim() !== '' && !context.startsWith('/')) {
            context = `/${context}`;
        }

        return (host ? protocol + '://' + host + port : '') + context;
    }
}
